import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { AssetTypeService } from './asset-type.service';
import { ApiAssetService } from 'src/app/api-services/asset.api.service';
import { Injectable } from '@angular/core';
import { ApiSceneAssetRelationService } from '../api-services/scene-asset-relation.api.service';
import { SceneAssetRelation } from '../models/scene-asset-relations/SceneAssetRelation';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { ApiQuestionResponseService } from '../api-services/question-response.api.service';
import { AssetInScene } from '../models/AssetInScene';
import { Model3DSceneAssetRelation } from '../models/scene-asset-relations/model3DSceneAssetRelation';
import { ApiVrEventAssetRelationService } from '../api-services/vr-event-asset-relation.api.service';
import { AssetEvent } from '../models/vr-events/AssetEvent';
import { VrEvent } from '../models/vr-events/VrEvent';
import { ApiAssetInBaseAssetService } from '../api-services/asset-in-base-asset.api.service';
import { AssetInBaseAsset } from '../models/assets-in-base-asset/AssetInBaseAsset';
import { QuestionSetAsset } from '../models/assets/QuestionSetAsset';
import { setRootDomAdapter } from '@angular/platform-browser/src/dom/dom_adapter';
import { ApiQuestionRuleService } from '../api-services/question-rule.api.service';
import { QuestionRule } from '../models/question-rules/QuestionRule';
import { OutcomeActionService } from './outcome-action.service';
import { InvisibleSceneAssetRelation } from '../models/scene-asset-relations/InvisibleSceneAssetRelation';
import { OutcomeAction } from '../models/outcomes/OutcomeAction';
import { DeepCopyService } from './deep-copy.service';
import { ApiAssetInQuestionResponseService } from '../api-services/asset-in-question-response.api.service';
import { QuestionResponse } from '../models/assets/QuestionResponse';
import { AssetInQuestionResponse } from '../models/assets-in-base-asset/AssetInQuestionResponse';
import { BaseAsset } from '../models/assets/BaseAsset';

@Injectable({
  providedIn: 'root'
})
export class GetAssetsFromDatabaseService {
  private _sceneAssetRelations: SceneAssetRelation[];
  private _assetOutcomeActions: OutcomeAction[];
  private _baseAssets: any[];

  constructor(
    public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
    public responseAPIService: ApiQuestionResponseService,
    public assetAPIService: ApiAssetService,
    public VrEventAssetRelationAPIService: ApiVrEventAssetRelationService,
    public VrEventAPIService: ApiVrEventService,
    public questionRuleAPIService: ApiQuestionRuleService,
    public assetTypeService: AssetTypeService,
    public assetInBaseAssetAPIService: ApiAssetInBaseAssetService,
    public outcomeActionsService: OutcomeActionService,
    public assetInQuestionResponseAPIService: ApiAssetInQuestionResponseService,
    public deepCopyService: DeepCopyService,
  ) {

  }

  getAssetsWithSceneIds(sceneIds: number[]): Promise<AssetInScene[]> {
    var assetsInScene: AssetInScene[] = [];
    return new Promise(async (resolve, reject) => {
      let baseAssetIds: number[] = [];
      this._sceneAssetRelations = await this.sceneAssetRelationAPIService.getSceneAssetRelationsWithSceneIds(sceneIds).toPromise();
      baseAssetIds = this._sceneAssetRelations.map(x => x.baseAssetId);
      this._baseAssets = await this.assetAPIService.getBaseAssetsWithBaseAssetIds(baseAssetIds).toPromise();

      let i: number = 0;
      this._sceneAssetRelations.forEach((sceneAssetRelation) => {
        this.getAssetInSceneWithSceneAssetRelation(sceneAssetRelation).then(assetForScene => {
          i++;
          if (assetForScene) {
            assetsInScene.push(assetForScene);
          }
          if (i == this._sceneAssetRelations.length) {
            resolve(assetsInScene);
          }
        });
      });
      if (this._sceneAssetRelations.length == 0) {
        resolve(assetsInScene);
      }
    });
  }

  getAssetWithSceneIdAssetRelationId(sceneId: number, assetSceneRelationId: number): Promise<AssetInScene> {
    var assetInScene: AssetInScene;
    return new Promise((resolve, reject) => {
      this.sceneAssetRelationAPIService.GetSceneAssetRelationsWithSceneIdAssetRelationId(sceneId, assetSceneRelationId).subscribe(sceneAssetRelation => {
        this.getAssetInSceneWithSceneAssetRelation(sceneAssetRelation, sceneAssetRelation.baseAssetId).then(assetForScene => {
          resolve(assetForScene);
        });
      });
    });
  }

  getAssetInSceneWithSceneAssetRelation(sceneAssetRelation: SceneAssetRelation, linkedBaseAssetId: number = 0): Promise<AssetInScene> {
    return new Promise<AssetInScene>(async (resolve, reject) => {
      var baseAsset = this._baseAssets.find(x => x.baseAssetId == sceneAssetRelation.baseAssetId);
      if(baseAsset){
        let assetType = this.assetTypeService.getType(baseAsset.assetTypeId);
        let assetsInBaseAsset: AssetInBaseAsset[] = [];
        let assetsInQuestionResponse: AssetInQuestionResponse[] = [];
        
        assetsInBaseAsset = await this.assetInBaseAssetAPIService.getAssetsInBaseAssetWithBaseAssetId(baseAsset.baseAssetId).toPromise();
        assetsInQuestionResponse = await this.assetInQuestionResponseAPIService.getAssetsInQuestionResponseWithSceneAssetRelationId(sceneAssetRelation.sceneAssetRelationId).toPromise();

        if (assetsInBaseAsset.length > 0 && linkedBaseAssetId == 0) {
          resolve(null);
        }else if(assetsInQuestionResponse.length > 0 && linkedBaseAssetId == 0){
          resolve(null);
        } else {
          var assetForScene: AssetInScene = new AssetInScene();
          

          switch (assetType) {
            case 'Model3D': {
              this.setUpAssetRotation(sceneAssetRelation as Model3DSceneAssetRelation);
              break;
            }
            case 'Invisible': {
              this.setUpAssetRotation(sceneAssetRelation as InvisibleSceneAssetRelation);
              break;
            }
            case 'QuestionSet': {
              var questionSetAsset = baseAsset as QuestionSetAsset;
              questionSetAsset.questionIndex = questionSetAsset.coverPage == true ? -1 : 0;
              break;
            }
          }

          this.setUpSceneAssetRelationParameters(sceneAssetRelation, assetType);
          assetForScene.baseAsset = baseAsset;
          assetForScene.sceneAssetRelation = sceneAssetRelation;
          assetForScene.expanded = false;
          assetForScene.toBeRemoved = false;
          assetForScene.events = [];
          assetForScene.assets = [];
          assetForScene.questionRules = [];
          assetForScene.outcomeActions = [];
          this._assetOutcomeActions = [];

          if (assetType == 'Question') {
            await this.getQuestionResponsesFromDb(assetForScene.baseAsset as QuestionAsset)
            assetForScene.questionRules = await this.getQuestionRulesFromDb(assetForScene.sceneAssetRelation.sceneAssetRelationId);
          }
          await this.getVrEventsAndAddAssetFromDb(assetForScene);
          if (assetType == 'QuestionSet') {
            await this.getAssetsInAssetsInSceneFromDb(assetForScene);
          }
          await this.getOutcomeActionsForAsset(assetForScene.sceneAssetRelation.sceneAssetRelationId);
          if(this._assetOutcomeActions.length !=0){
            assetForScene.outcomeActions = this.deepCopyService.deepCopy(this._assetOutcomeActions);
          }
          resolve(assetForScene);
        }
      }
    });
  }
  
  getOutcomeActionsForAsset(id): Promise<boolean>{
    return new Promise<boolean>(async (resolve) => {
      await this.outcomeActionsService.getOutcomeActionBySceneAssetRelationId(id).then(x=>{
        this._assetOutcomeActions = x;
        resolve(true);
      });
    });
  }

  setUpAssetRotation(sceneAssetRelation) {

    if (!sceneAssetRelation.xRot)
      sceneAssetRelation.xRot = "0";
    if (!sceneAssetRelation.yRot)
      sceneAssetRelation.yRot = "0";
    if (!sceneAssetRelation.zRot)
      sceneAssetRelation.zRot = "0";

    sceneAssetRelation.rotation = sceneAssetRelation.xRot + ' ' + sceneAssetRelation.yRot + ' ' + sceneAssetRelation.zRot;
  }

  setUpSceneAssetRelationParameters(relation: SceneAssetRelation, assetType: string) {
    switch (assetType) {
      case 'Text': {
        this.setUpAssetScale(relation, relation.xScale, relation.xScale, relation.zScale);
        break;
      }
      case 'HotSpot': {
        this.setUpAssetScale(relation, relation.xScale, relation.xScale, relation.zScale);
        break;
      }
      default: {
        this.setUpAssetScale(relation, relation.xScale, relation.yScale, relation.zScale);
        break;
      }
    }
    this.setUpAssetPosition(relation, relation.xPos, relation.yPos, relation.zPos);
  }

  setUpAssetScale(sceneAssetRelation: SceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  setUpAssetPosition(sceneAssetRelation: SceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xPos = x;
    sceneAssetRelation.yPos = y;
    sceneAssetRelation.zPos = z;
    sceneAssetRelation.position = x + ' ' + y + ' ' + z;
  }

  getQuestionResponsesFromDb(baseAsset: QuestionAsset): Promise<void> {
    var promise = new Promise<void>((resolve, reject) => {
      if (baseAsset) {
        this.responseAPIService.GetQuestionResponsesWithQuestionAssetId(baseAsset.baseAssetId).subscribe(async responses => {
          var sortedResponses = responses.sort((a, b) => a.questionResponseIndex > b.questionResponseIndex ? 1 : -1);
          baseAsset.responses = sortedResponses;
          for(let i: number = 0; i < baseAsset.responses.length; i++){
            let response = baseAsset.responses[i];
            await this.getAssetsInQuestionResponsesFromDb(response);
          }
          resolve();
        });
      }else{
        resolve();
      }
    });
    return promise;
  }

  getVrEventsAndAddAssetFromDb(assetForScene: AssetInScene): Promise<void> {
    var promise = new Promise<void>((resolve, reject) => {
      this.VrEventAssetRelationAPIService.getVrEventAssetRelationsWithSceneAssetRelationId(assetForScene.sceneAssetRelation.sceneAssetRelationId).subscribe(VrEventAssetRelations => {
        let i: number = 0;
        VrEventAssetRelations.forEach((VrEventAssetRelation) => {
          this.VrEventAPIService.getVrEvent(VrEventAssetRelation.vrEventId).subscribe(VrEvent => {
            i++;
            var assetEvent: AssetEvent = {
              vrEventId: VrEvent.vrEventId,
              eventTypeId: VrEvent.eventTypeId,
              eventTriggerId: VrEvent.eventTriggerId,
              linkedContentId: VrEvent.linkedContentId,
              sceneAssetRelationId: VrEventAssetRelation.sceneAssetRelationId,
            }

            assetForScene.events.push(assetEvent);
            if (i == VrEventAssetRelations.length) {
              resolve();
            }
          });
        });
        if (VrEventAssetRelations.length == 0) {
          resolve();
        }
      });
    });
    return promise;
  }

  getQuestionRulesFromDb(sceneAssetRelationId: number): Promise<QuestionRule[]> {
    var promise = new Promise<QuestionRule[]>((resolve, reject) => {
      this.questionRuleAPIService.getQuestionRulesWithSceneAssetRelationId(sceneAssetRelationId).subscribe(questionRules => {
        var questionRulesResolve: QuestionRule[] = [];
        if (questionRules) {
          questionRulesResolve = questionRules;
        }
        resolve(questionRulesResolve);
      });
    });
    return promise;
  }

  getAssetsInAssetsInSceneFromDb(assetInScene: AssetInScene): Promise<AssetInScene[]> {
    assetInScene.assets = [];
    var baseAssetId: number = assetInScene.baseAsset.baseAssetId;
    return new Promise((resolve, reject) => {
      this.assetInBaseAssetAPIService.getAssetsInBaseAssetWithLinkedBaseAssetId(baseAssetId).subscribe(async assetsInBaseAsset => {
        assetsInBaseAsset = assetsInBaseAsset.sort((a, b) => a.assetInBaseAssetIndex > b.assetInBaseAssetIndex ? 1 : -1);
        for (let i = 0; i < assetsInBaseAsset.length; i++) {
          var sceneAssetRelation = this._sceneAssetRelations.find(s => s.baseAssetId == assetsInBaseAsset[i].baseAssetId);
          if (sceneAssetRelation) {
            var assetForScene: AssetInScene = await this.getAssetInSceneWithSceneAssetRelation(sceneAssetRelation, baseAssetId);
            if (assetForScene) {
              assetInScene.assets.push(assetForScene);
            }
          }
        }
        resolve(assetInScene.assets);
      });
    });
  }

  getAssetsInQuestionResponsesFromDb(questionResponse: QuestionResponse): Promise<AssetInScene[]> {
    questionResponse.assets = [];
    return new Promise((resolve, reject) => {
      this.assetInQuestionResponseAPIService.getAssetsInQuestionResponseWithLinkedQuestionResponseId(questionResponse.questionResponseId).subscribe(async assetsInQuestionResponse => {
        assetsInQuestionResponse = assetsInQuestionResponse.sort((a, b) => a.assetInQuestionResponseIndex > b.assetInQuestionResponseIndex ? 1 : -1);
        for (let i = 0; i < assetsInQuestionResponse.length; i++) {
          var sceneAssetRelation = this._sceneAssetRelations.find(s => s.sceneAssetRelationId == assetsInQuestionResponse[i].sceneAssetRelationId);
          if (sceneAssetRelation) {
            var assetForScene: AssetInScene = await this.getAssetInSceneWithSceneAssetRelation(sceneAssetRelation, questionResponse.questionResponseId);
            if (assetForScene) {
              questionResponse.assets.push(assetForScene);
            }
          }
        }
        resolve(questionResponse.assets);
      });
    });
  }

}
